module.exports = __webpack_public_path__ + "assets/img/block-left-3cb3a31b.png";